var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { MapSchema, Schema, type } from "@colyseus/schema";
export class PlayerState extends Schema {
    constructor() {
        super(...arguments);
        this.id = "";
        this.name = "";
        this.color = "#ffffff";
        this.sectionId = "bridge";
        this.destinationSectionId = "";
        this.travelFromSectionId = "";
        this.travelToSectionId = "";
        this.travelStartedAt = 0;
        this.travelEndsAt = 0;
        this.route = "";
        this.ready = false;
        this.connected = true;
        this.suitOn = false;
        this.health = 100;
        this.activeActionId = "";
        this.actionStartedAt = 0;
        this.actionEndsAt = 0;
    }
}
__decorate([
    type("string")
], PlayerState.prototype, "id", void 0);
__decorate([
    type("string")
], PlayerState.prototype, "name", void 0);
__decorate([
    type("string")
], PlayerState.prototype, "color", void 0);
__decorate([
    type("string")
], PlayerState.prototype, "sectionId", void 0);
__decorate([
    type("string")
], PlayerState.prototype, "destinationSectionId", void 0);
__decorate([
    type("string")
], PlayerState.prototype, "travelFromSectionId", void 0);
__decorate([
    type("string")
], PlayerState.prototype, "travelToSectionId", void 0);
__decorate([
    type("number")
], PlayerState.prototype, "travelStartedAt", void 0);
__decorate([
    type("number")
], PlayerState.prototype, "travelEndsAt", void 0);
__decorate([
    type("string")
], PlayerState.prototype, "route", void 0);
__decorate([
    type("boolean")
], PlayerState.prototype, "ready", void 0);
__decorate([
    type("boolean")
], PlayerState.prototype, "connected", void 0);
__decorate([
    type("boolean")
], PlayerState.prototype, "suitOn", void 0);
__decorate([
    type("number")
], PlayerState.prototype, "health", void 0);
__decorate([
    type("string")
], PlayerState.prototype, "activeActionId", void 0);
__decorate([
    type("number")
], PlayerState.prototype, "actionStartedAt", void 0);
__decorate([
    type("number")
], PlayerState.prototype, "actionEndsAt", void 0);
export class SectionState extends Schema {
    constructor() {
        super(...arguments);
        this.id = "";
        this.oxygen = 100;
        this.pressure = 100;
        this.temperature = 22;
        this.smoke = 0;
        this.fire = 0;
        this.powered = true;
        this.venting = false;
    }
}
__decorate([
    type("string")
], SectionState.prototype, "id", void 0);
__decorate([
    type("number")
], SectionState.prototype, "oxygen", void 0);
__decorate([
    type("number")
], SectionState.prototype, "pressure", void 0);
__decorate([
    type("number")
], SectionState.prototype, "temperature", void 0);
__decorate([
    type("number")
], SectionState.prototype, "smoke", void 0);
__decorate([
    type("number")
], SectionState.prototype, "fire", void 0);
__decorate([
    type("boolean")
], SectionState.prototype, "powered", void 0);
__decorate([
    type("boolean")
], SectionState.prototype, "venting", void 0);
export class LogEntryState extends Schema {
    constructor() {
        super(...arguments);
        this.id = "";
        this.at = 0;
        this.level = "info";
        this.text = "";
    }
}
__decorate([
    type("string")
], LogEntryState.prototype, "id", void 0);
__decorate([
    type("number")
], LogEntryState.prototype, "at", void 0);
__decorate([
    type("string")
], LogEntryState.prototype, "level", void 0);
__decorate([
    type("string")
], LogEntryState.prototype, "text", void 0);
export class CrewState extends Schema {
    constructor() {
        super(...arguments);
        this.phase = "lobby";
        this.result = "";
        this.roomCode = "";
        this.visibility = "private";
        this.ownerId = "";
        this.missionStartedAt = 0;
        this.missionElapsed = 0;
        this.reactorStability = 100;
        this.hullIntegrity = 100;
        this.oxygenLeak = false;
        this.cargoSecured = true;
        this.gridIntegrity = 100;
        this.powerMode = "balanced";
        this.alertLevel = "nominal";
        this.players = new MapSchema();
        this.sections = new MapSchema();
        this.logs = new MapSchema();
    }
}
__decorate([
    type("string")
], CrewState.prototype, "phase", void 0);
__decorate([
    type("string")
], CrewState.prototype, "result", void 0);
__decorate([
    type("string")
], CrewState.prototype, "roomCode", void 0);
__decorate([
    type("string")
], CrewState.prototype, "visibility", void 0);
__decorate([
    type("string")
], CrewState.prototype, "ownerId", void 0);
__decorate([
    type("number")
], CrewState.prototype, "missionStartedAt", void 0);
__decorate([
    type("number")
], CrewState.prototype, "missionElapsed", void 0);
__decorate([
    type("number")
], CrewState.prototype, "reactorStability", void 0);
__decorate([
    type("number")
], CrewState.prototype, "hullIntegrity", void 0);
__decorate([
    type("boolean")
], CrewState.prototype, "oxygenLeak", void 0);
__decorate([
    type("boolean")
], CrewState.prototype, "cargoSecured", void 0);
__decorate([
    type("number")
], CrewState.prototype, "gridIntegrity", void 0);
__decorate([
    type("string")
], CrewState.prototype, "powerMode", void 0);
__decorate([
    type("string")
], CrewState.prototype, "alertLevel", void 0);
__decorate([
    type({ map: PlayerState })
], CrewState.prototype, "players", void 0);
__decorate([
    type({ map: SectionState })
], CrewState.prototype, "sections", void 0);
__decorate([
    type({ map: LogEntryState })
], CrewState.prototype, "logs", void 0);
//# sourceMappingURL=state.js.map